import { Badge, type BadgeProps } from "@atlas/core";
import { IHubCatalogVisibility } from "@enums";
import type { ReactElement } from "react";

type HubCatalogVisibilityBadgeVariant =
  | "neutral"
  | "info"
  | "destructive"
  | "success"
  | "warning"
  | "intelligence"
  | "primary"
  | "secondary";

interface IHubCatalogVisibilityBadge {
  id: string;
  label: string;
  variant: HubCatalogVisibilityBadgeVariant;
  appearance: BadgeProps["appearance"];
  size: BadgeProps["size"];
}

type HubCatalogVisibilityTranslate = (
  key: string,
  options?: { defaultValue?: string },
) => string;

export function resolveHubCatalogVisibilityBadge(
  visibility: IHubCatalogVisibility,
  t: HubCatalogVisibilityTranslate,
): IHubCatalogVisibilityBadge | null {
  switch (visibility) {
    case IHubCatalogVisibility.Private:
      return {
        id: "visibility-private",
        label: t("hub.catalog_manager.visibility_private", {
          defaultValue: "Private",
        }),
        variant: "warning",
        appearance: "light",
        size: "sm",
      };
    case IHubCatalogVisibility.Company:
      return {
        id: "visibility-company",
        label: t("hub.catalog_manager.visibility_company", {
          defaultValue: "Company",
        }),
        variant: "intelligence",
        appearance: "light",
        size: "sm",
      };
    case IHubCatalogVisibility.Platform:
      return {
        id: "visibility-platform",
        label: t("hub.catalog_manager.visibility_platform", {
          defaultValue: "Platform",
        }),
        variant: "primary",
        appearance: "light",
        size: "sm",
      };
    /* case IHubCatalogVisibility.Global:
      return {
        id: "visibility-global",
        label: t("hub.catalog_manager.visibility_global", {
          defaultValue: "Global",
        }),
        variant: "success",
        appearance: "light",
        size: "sm",
      }; */
    default:
      return null;
  }
}

type HubCatalogVisibilityBadgeElementProps = Omit<
  BadgeProps,
  "children" | "variant"
>;

export function getHubCatalogVisibilityBadge(
  visibility: IHubCatalogVisibility,
  t: HubCatalogVisibilityTranslate,
  badgeProps?: HubCatalogVisibilityBadgeElementProps,
): ReactElement | null {
  const meta = resolveHubCatalogVisibilityBadge(visibility, t);
  if (!meta) return null;
  return (
    <Badge
      size={meta.size}
      appearance={meta.appearance}
      variant={meta.variant}
      {...badgeProps}>
      {meta.label}
    </Badge>
  );
}
